<generic-container textAlign="left" bold="last" titleKey='ADDITIONAL_QUESTION'>
    <faq [faqs]="faqs" [showLabels]="false" [faqLimit]="3"></faq>
</generic-container>